/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicProgramStatusUpdateReport', 'model/StrategicProgramStatusUpdate', 'model/StrategicProgramStatusUpdateReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategicProgramStatusUpdateReport'), require('../model/StrategicProgramStatusUpdate'), require('../model/StrategicProgramStatusUpdateReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicProgramStatusUpdateApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicProgramStatusUpdateReport, root.ForStractionServiceApi.StrategicProgramStatusUpdate, root.ForStractionServiceApi.StrategicProgramStatusUpdateReportPaginationSlice);
  }
}(this, function(ApiClient, StrategicProgramStatusUpdateReport, StrategicProgramStatusUpdate, StrategicProgramStatusUpdateReportPaginationSlice) {
  'use strict';

  /**
   * StrategicProgramStatusUpdate service.
   * @module api/StrategicProgramStatusUpdateApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategicProgramStatusUpdateApi. 
   * @alias module:api/StrategicProgramStatusUpdateApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateAddPut operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgramStatusUpdateReport} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.updateIndicatorActualData  (default to false)
     * @param {Boolean} opts.addInsight  (default to false)
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategicProgramStatusUpdateAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramStatusUpdateAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'updateIndicatorActualData': opts['updateIndicatorActualData'],
        'addInsight': opts['addInsight']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateClearProgramStatusUpdatesGet operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateClearProgramStatusUpdatesGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearProgramStatusUpdates
     * @param {String} _4SAPIAppID 
     * @param {Integer} programID 
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateClearProgramStatusUpdatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramStatusUpdateClearProgramStatusUpdatesGet = function(_4SAPIAppID, programID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateClearProgramStatusUpdatesGet";
      }

      // verify the required parameter 'programID' is set
      if (programID == undefined || programID == null) {
        throw "Missing the required parameter 'programID' when calling strategicProgramStatusUpdateClearProgramStatusUpdatesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'programID': programID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/clearProgramStatusUpdates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateDeleteGet operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} statusUpdateID 
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramStatusUpdateDeleteGet = function(_4SAPIAppID, statusUpdateID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateDeleteGet";
      }

      // verify the required parameter 'statusUpdateID' is set
      if (statusUpdateID == undefined || statusUpdateID == null) {
        throw "Missing the required parameter 'statusUpdateID' when calling strategicProgramStatusUpdateDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'statusUpdateID': statusUpdateID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateEditPut operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgramStatusUpdate} body 
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicProgramStatusUpdateEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramStatusUpdateEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateSearchPut operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicProgramStatusUpdateReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicProgramStatusUpdate>} body 
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicProgramStatusUpdateReport>}
     */
    this.strategicProgramStatusUpdateSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramStatusUpdateSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicProgramStatusUpdateReport];

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicProgramStatusUpdateSearchSlicePut operation.
     * @callback module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicProgramStatusUpdateReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicProgramStatusUpdate} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/StrategicProgramStatusUpdateApi~strategicProgramStatusUpdateSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicProgramStatusUpdateReportPaginationSlice}
     */
    this.strategicProgramStatusUpdateSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicProgramStatusUpdateSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicProgramStatusUpdateSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicProgramStatusUpdateReportPaginationSlice;

      return this.apiClient.callApi(
        '/StrategicProgramStatusUpdate/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
